import { render, staticRenderFns } from "./EnrolmentOrganisationUserForm.vue?vue&type=template&id=73817672&"
import script from "./EnrolmentOrganisationUserForm.vue?vue&type=script&lang=js&"
export * from "./EnrolmentOrganisationUserForm.vue?vue&type=script&lang=js&"
import style0 from "./EnrolmentOrganisationUserForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports